<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            Traitement souhaité
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <div v-if="selected" class="font-bold">
                    <template v-if="selected.process == 'echange'">Echange</template>
                    <template v-if="selected.process == 'reparation'">Réparation</template>
                    <template v-if="selected.process == 'remboursement'">Remboursemen</template>
                </div>
                <div class="font-light text-sm">{{selected.comment}}</div>
            </template>

            <template v-slot:open>
                <div v-if="error" class="bg-red-200 p-4 my-rounded text-white text-red-600 mb-3 font-bold">{{error}}</div>
                <div @click="error = null; selectedProcess = 'echange'" class="relative flex gap-2 min-w-0 mb-3 break-words duration-200 bg-white border border-gray-300 rounded cursor-pointer border-1 my-rounded p-6"  :class="selectedProcess == 'echange' ? 'bg-slate-100' : 'hover:shadow hover:border-gray-350 hover:bg-gray-50'">
                    <i v-if="selectedProcess == 'echange'" class='fas fa-check-circle text-green-500 mt-0.5'></i> Échange contre un produit neuf
                </div>
                <div @click="error = null; selectedProcess = 'reparation'" class="relative flex gap-2 min-w-0 mb-3 break-words duration-200 bg-white border border-gray-300 rounded cursor-pointer border-1 my-rounded p-6"  :class="selectedProcess == 'reparation' ? 'bg-slate-100' : 'hover:shadow hover:border-gray-350 hover:bg-gray-50'">
                    <i v-if="selectedProcess == 'reparation'" class='fas fa-check-circle text-green-500 mt-0.5'></i> Réparation
                </div>
                <div @click="error = null; selectedProcess = 'remboursement'" class="relative flex gap-2 min-w-0 mb-3 break-words duration-200 bg-white border border-gray-300 rounded cursor-pointer border-1 my-rounded p-6" :class="selectedProcess == 'remboursement' ? 'bg-slate-100' : 'hover:shadow hover:border-gray-350 hover:bg-gray-50'">
                    <i v-if="selectedProcess == 'remboursement'" class='fas fa-check-circle text-green-500 mt-0.5'></i> Remboursement
                </div>
                <div class="text-xs">En cas de demande de service après-vente, chaque situation est examinée individuellement. Selon les circonstances, nous nous réservons le droit de vous orienter vers une autre solution que celle demandée, en respetant les conditions de garantie et la politique interne de notre entreprise.</div>
                <sav-input v-model="comment" type="textarea" class="mt-5" :label="$tt('Commentaire')" />
                <button @click="end({comment: comment, process: selectedProcess})" class="px-4 py-2 bg-green-600 hover:bg-green-700 duration-200 text-white rounded text-sm mt-4">
                    <i class='fas fa-check mr-1'></i> Valider
                </button>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'choose-process',
    extends: FormCardExtension,
    data() {
        return {
            selectedProcess: null,
            comment: null,
            error: null,
        }
    },

    methods: {
        init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.getNextBlock()
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.loading = false
        },

        end(callbackData) {
            this.error = null
            if (!this.selectedProcess) {
                this.error = this.$tt('Merci de renseigné un traitement ci-dessous')
                return
            }

            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = this.getNextBlock()
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        getNextBlock() {
            if (!this.$formTool.getFormData('proc').adresse_client || this.$formTool.getFormData('proc').adresse_client.mandatory == '1') {
                return this.$formTool.blockData(this.$options.name).next.address
            } else {
                return this.$formTool.blockData(this.$options.name).next.default
            }
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/warranty/ChooseProcess.vue